module.exports = __webpack_public_path__ + "img/baked.81c00178.jpg";